module.exports = __webpack_public_path__ + "static/media/ico-profile.76b4d3fd.svg";